module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAA4ElEQVQ4T43TvQrCMBAH8EsXwUFXfREfwjdwcxJcxE1NlwMt0Uns5iC+i76Gq3RwUaHUVE0kRYul+ehtIf8fyR0cAQBAxMaL896Csa0624qoS0ppG+T77IE3dKEMIGI95UkMANKFMqDK92cjKcTGhXJQFRVAFVQCLqQFNmQEJmQFXzSWQqzV9ICQgRUgovdMHzspZR8AYuJB1wh04SBYHbTAFFZfLAFbuARc4QKoEi4An073/9NQDer2IuthuZw07ze4/kZnCucvIGIr5clJzdkWzkEYhrVLFHXmjB1dK/oBFRu5kFV3DTQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/ssjg_mbx_jt@2x.png
// module id = j1vW
// module chunks = 0